import * as React from 'react';
const UI_KIT_FOCUS_GUARD_ATTRIBUTE = 'data-cian-ui-kit-focus-guard';

/** Количество компонентов, которые запросили FocusGuards */
let count = 0;

/**
 * Вставляет пару DOM элементов на границы всего DOM-дерева,
 * чтобы гарантировать, что события `focusin` и `focusout` могут быть пойманы последовательно.
 */
export function useFocusGuards() {
  React.useEffect(() => {
    var _edgeGuards$, _edgeGuards$2;
    const edgeGuards = document.querySelectorAll("[".concat(UI_KIT_FOCUS_GUARD_ATTRIBUTE, "]"));
    document.body.insertAdjacentElement('afterbegin', (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : createFocusGuard());
    document.body.insertAdjacentElement('beforeend', (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : createFocusGuard());
    count++;
    return () => {
      if (count === 1) {
        document.querySelectorAll("[".concat(UI_KIT_FOCUS_GUARD_ATTRIBUTE, "]")).forEach(node => node.remove());
      }
      count--;
    };
  }, []);
}
function createFocusGuard() {
  const element = document.createElement('span');
  element.setAttribute(UI_KIT_FOCUS_GUARD_ATTRIBUTE, '');
  element.tabIndex = 0;
  element.style.outline = 'none';
  element.style.opacity = '0';
  element.style.position = 'fixed';
  element.style.pointerEvents = 'none';
  return element;
}